
import { Vue, Options } from 'vue-class-component'
import { InjectReactive, Prop, Watch } from 'vue-property-decorator'
import TextboxField from '@/components/validateFields/TextboxField.vue'
import InputOnlyNumber from '@/components/common/InputOnlyNumber.vue'
import IconTrash from '@/components/svg/IconTrash.vue'
import { IAdjustmentCustomFieldRoute, IProjectCustomField, ITrackPointForms, ITrackPointKeyVal } from '@/utils/types'
import { ECustomFieldUnitPosition } from '@/utils/enums'
import { isEmpty, objectToArray } from '@/utils/helpers'

@Options({
  components: { TextboxField, InputOnlyNumber, IconTrash },
  name: 'Number',
})
export default class Number extends Vue {
  @InjectReactive() trackingPointDatasArr!: ITrackPointKeyVal[]
  @Prop({ type: Object }) readonly customField!: IProjectCustomField
  _trackPointRoutePath!: IAdjustmentCustomFieldRoute[]

  get positionTypes(): Record<string, string> {
    return {
      [ECustomFieldUnitPosition.PREFIX]: 'prefix',
      [ECustomFieldUnitPosition.SUFFIX]: 'suffix',
    }
  }

  get getTrackPointRoutes(): IAdjustmentCustomFieldRoute[] {
    return this.customField?.trackPointRoutes || []
  }

  @Watch('trackingPointDatasArr')
  trackingPointDatasable() {
    const ableArray = this.trackingPointDatasArr.filter((val) => {
      return !val.value.isEnd
    })

    return ableArray
  }

  @Watch('trackingPointDatasArr')
  getNextTrackpointsForm(key: string) {
    return objectToArray<ITrackPointForms>(
      this.trackingPointDatasArr.find((tp) => tp.key === key)?.value.trackPointForms || {}
    ).map((val) => ({
      key: val.key,
      value: {
        ...val.value,
        name: this.trackingPointDatasArr.find((tp) => tp.key === val.key)?.value.name,
      },
    }))
  }

  mounted() {
    if (this.customField.position === ECustomFieldUnitPosition.UNKNOWN) {
      this.customField.position = ECustomFieldUnitPosition.DEFAULT
    }
  }

  onPathChange(route: IAdjustmentCustomFieldRoute) {
    route.to = this.getEndRouteAvailable(route.from)?.[0]?.key || ''
  }

  getEndRouteAvailable(startedKey: string) {
    const found = this.getTrackPointRoutes.filter((v) => v.from === startedKey)
    return this.getNextTrackpointsForm(startedKey).filter((o) => !found.find((v) => v.to === o.key))
  }

  isDisableStartRoute(trackpoint: ITrackPointKeyVal) {
    return isEmpty(this.getEndRouteAvailable(trackpoint.key))
  }

  isDisableEndRoute(tp: ITrackPointKeyVal, startedRoute: string) {
    return !!this.customField?.trackPointRoutes?.find((v) => v.from === startedRoute && v.to === tp.key)
  }

  deleteRoutePath(idx: number) {
    if (this.customField?.trackPointRoutes) {
      this.customField.trackPointRoutes.splice(idx, 1)
    }
  }

  onAddRoute() {
    this.customField.trackPointRoutes = this.customField.trackPointRoutes ?? []
    this.customField.trackPointRoutes.push({
      from: '',
      to: '',
      customLabel: '',
    })
  }
}
